import Box from '@mui/material/Box';
import { useIsMobile } from '@repo/mui-config/hooks';
import { ModalHeader, Modal } from '@repo/ui';

import type { ModalProps } from '../display-modal';
import { ModalContent } from '../modal-content';

export function ModalRepresentativeAddressData({
  modalState,
  isModalOpen,
  closeModal,
}: ModalProps) {
  const isMobile = useIsMobile();

  return (
    <Modal
      slotProps={{
        paper: {
          sx: {
            borderRadius: '10px',
            position: 'absolute',
          },
        },
      }}
      isOpen={isModalOpen}
      maxWidth="sm"
    >
      <Box sx={{ py: 4, px: isMobile ? '20px' : '44px' }}>
        <ModalHeader
          centeredLogo={false}
          closeButton={{ isVisible: true, onClick: closeModal }}
          sx={{ mb: '20px' }}
        />
        <ModalContent modalType={modalState} />
      </Box>
    </Modal>
  );
}
